import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useWatchError } from '@/domain/app';
import { useTranslations } from '@/domain/translations';
import { KbPaymentForm } from '@/pages/transactions/components/KbTransactions/components/PaymentForm/PaymentSchema';

import RowButtonModal from '@components/rowbutton-modal/RowButtonModal';
import { formatAccountNumber } from '@utils/account-utils';

import { SelectPayee } from './SelectPayee';

type Props = {
    disabled?: boolean;
    locked?: boolean;
};

export const PayeeField = ({ disabled = false, locked = false }: Props) => {
    const [showModal, setShowModal] = useState(false);
    const t = useTranslations();
    const methods = useFormContext();

    const accountNumber = methods.watch('payeeAccountNumber');
    const accountName = methods.watch('payeeName');
    const error = useWatchError<KbPaymentForm>('payeeAccountNumber', 'pay.validation.payeeAccountNumber.required');
    const errorName = useWatchError<KbPaymentForm>('payeeName', 'pay.validation.payeeName.required');

    return (
        <RowButtonModal
            label={t.pay.payeeField.title}
            placeholder={t.pay.payeeField.placeholder}
            accountAlias={accountNumber ? formatAccountNumber(accountNumber) : ''}
            accountNumber={accountName}
            error={error || errorName}
            disabled={disabled}
            locked={locked}
            subModalTitle={t.pay.payeeField.subTitle}
            subModalId="receiverAccountField"
            showModal={showModal}
            triggerModal={setShowModal}
            onModalClose={() => setShowModal(false)}
        >
            <SelectPayee onClose={() => setShowModal(false)} />
        </RowButtonModal>
    );
};
